var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screen"},[(_vm.screen)?_c(_vm.screen.type,{key:_vm.screen.index,tag:"component",attrs:{"screen":_vm.screen},on:{"action":_vm.onAction}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }